import React, {Component} from 'react';
import {SketchPicker} from 'react-color';

import './Visualizer.css';
import './Piano.css';

const noteNameToIndex = {
  C: 0,
  'C#': 1,
  D: 2,
  'D#': 3,
  E: 4,
  F: 5,
  'F#': 6,
  G: 7,
  'G#': 8,
  A: 9,
  'A#': 10,
  B: 11,
};

function PianoKey(props) {
  return (
    <div
      style={{
        backgroundColor: props.colors[noteNameToIndex[props.noteName]],
        borderColor:
          props.noteName === props.activeNoteName ? 'white' : 'black',
      }}
      className={`Piano__${props.black ? 'Black' : 'White'}Key ${
        props.noMargin ? 'no-margin' : ''
      }`}
      onClick={() => props.onClickNote(props.noteName)}
    >
      {/* props.noteName */}
    </div>
  );
}

export class Piano extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedNote: 'C',
    };
  }

  onClickNote = selectedNote => {
    this.setState({
      selectedNote,
      pickingColor: !(
        selectedNote === this.state.selectedNote && this.state.pickingColor
      ),
    });
  };

  onChangeNoteColor = e => {
    this.props.colors[noteNameToIndex[this.state.selectedNote]] = `rgba(${
      e.rgb.r
    }, ${e.rgb.g}, ${e.rgb.b}, ${e.rgb.a})`;

    this.props.onChangeColors(this.props.colors);
  };

  renderOctave() {
    return (
      <div className="Piano__Octave">
        <PianoKey
          colors={this.props.colors}
          activeNoteName={this.props.noteName}
          onClickNote={this.onClickNote}
          noteName="C"
          noMargin
        />
        <PianoKey
          colors={this.props.colors}
          activeNoteName={this.props.noteName}
          onClickNote={this.onClickNote}
          noteName="C#"
          black
        />
        <PianoKey
          colors={this.props.colors}
          activeNoteName={this.props.noteName}
          onClickNote={this.onClickNote}
          noteName="D"
        />
        <PianoKey
          colors={this.props.colors}
          activeNoteName={this.props.noteName}
          onClickNote={this.onClickNote}
          noteName="D#"
          black
        />
        <PianoKey
          colors={this.props.colors}
          activeNoteName={this.props.noteName}
          onClickNote={this.onClickNote}
          noteName="E"
        />
        <PianoKey
          colors={this.props.colors}
          activeNoteName={this.props.noteName}
          onClickNote={this.onClickNote}
          noteName="F"
          noMargin
        />
        <PianoKey
          colors={this.props.colors}
          activeNoteName={this.props.noteName}
          onClickNote={this.onClickNote}
          noteName="F#"
          black
        />
        <PianoKey
          colors={this.props.colors}
          activeNoteName={this.props.noteName}
          onClickNote={this.onClickNote}
          noteName="G"
        />
        <PianoKey
          colors={this.props.colors}
          activeNoteName={this.props.noteName}
          onClickNote={this.onClickNote}
          noteName="G#"
          black
        />
        <PianoKey
          colors={this.props.colors}
          activeNoteName={this.props.noteName}
          onClickNote={this.onClickNote}
          noteName="A"
        />
        <PianoKey
          colors={this.props.colors}
          activeNoteName={this.props.noteName}
          onClickNote={this.onClickNote}
          noteName="A#"
          black
        />
        <PianoKey
          colors={this.props.colors}
          activeNoteName={this.props.noteName}
          onClickNote={this.onClickNote}
          noteName="B"
        />
      </div>
    );
  }

  render() {
    return (
      <div>
        <div className="Piano">{this.renderOctave()}</div>
        {this.state.pickingColor ? (
          <div style={{position: 'absolute'}}>
            <SketchPicker
              color={
                this.props.colors[noteNameToIndex[this.state.selectedNote]]
              }
              onChange={this.onChangeNoteColor}
            />
          </div>
        ) : null}
      </div>
    );
  }
}

export default class Visualizer extends Component {
  render() {
    const {
      background,
      onChangeCollapse,
      onClickDownloadImage,
      onChangeBackground,
      currentSketchName,
      brushName,
      onChangeBrush,
      p5State,
      sketches,
      onChangeSketch,
      onChangeSlider1,
      slider1Value,
    } = this.props;
    return (
      <div className={'Visualizer'} onClick={onChangeCollapse}>
        <div className="row">
          <div
            className="Visualizer__Color"
            style={{
              height: 50,
              width: 50,
              backgroundColor: p5State.spectrumColor,
            }}
          />

          <strong>Brush: </strong>
          <select
            onClick={e => e.stopPropagation()}
            style={{marginRight: '15px'}}
            label="Visualization"
            id=""
            name=""
            onChange={onChangeBrush}
            value={brushName}
          >
            <option value="Water Color">Water Color</option>
            <option value="Circle">Circle</option>
            <option value="Square">Square</option>
          </select>

          <strong>Visualization: </strong>
          <select
            onClick={e => e.stopPropagation()}
            style={{marginRight: '15px'}}
            onChange={onChangeSketch}
            value={currentSketchName}
          >
            {Object.keys(sketches).map((name, i) => (
              <option key={i} value={name}>
                {name}
              </option>
            ))}
          </select>

          {p5State.slider1 && (
            <div>
              <strong>{p5State.slider1.label}: </strong>
              <input
                onClick={e => e.stopPropagation()}
                style={{marginRight: 15}}
                name="slider1"
                type="range"
                value={slider1Value || 0}
                min={p5State.slider1.min}
                max={p5State.slider1.max}
                onChange={onChangeSlider1}
                step="1"
              />
            </div>
          )}

          <div className="Visualizer__Note">
            <strong>Note:</strong>
            {p5State.noteName || 'Unknown'}
          </div>

          <div className="Visualizer__Frequency">
            <strong>Frequency:</strong>
            {p5State.frequency && p5State.frequency.toFixed(2)}
          </div>

          <div className="Visualizer__Level">
            <strong>Level:</strong>
            {p5State.level && p5State.level.toFixed(3)}
          </div>

          <div className="Visualizer__Level">
            <strong>Hold Draw:</strong>
            <input
              name=""
              type="checkbox"
              checked={this.props.holdDraw}
              onChange={this.props.onToggleHoldDraw}
            />
          </div>
        </div>

        <div className="row">
          <div>
            <strong>Background Color:</strong>
          </div>

          <div style={{maxWidth: 100}}>
            <SketchPicker color={background} onChange={onChangeBackground} />
          </div>

          <div>
            <strong style={{marginLeft: 15}}>
              <a href="#download" onClick={onClickDownloadImage}>
                Download Image
              </a>
            </strong>
          </div>
        </div>

        <div className="row">
          <Piano
            noteName={p5State.noteName}
            colors={this.props.colors}
            onChangeColors={this.props.onChangeColors}
          />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Visualizer.js